export type TaskOwnerViewableKind =
    | "ALL"
    | "UNOWNED"
    | "CLIENT"
    | "COMMUNITY"
    | "REFERENCECONTACT"
    | "REFERENCEBUSINESS";

export const AnnotatedViewableTaskTypes = [
    { name: "All Associations", kind: "ALL" },
    // { name: 'Unaffiliated', kind: 'UNOWNED' },
    { name: "Clients", kind: "CLIENT" },
    { name: "Communities", kind: "COMMUNITY" },
    { name: "Referral Contacts", kind: "REFERENCECONTACT" },
    { name: "Referral Organizations", kind: "REFERENCEBUSINESS" },
];
